module.exports = __webpack_public_path__ + "static/media/future-2.36dfc388.jpg";